import { useState } from "react";

/*
    Shared date-range filter.
    Screens filter by createdAt unless another field is provided.
    Both ends of a custom range are inclusive.
*/

export const DATE_RANGES = [
    { value: "", label: "Cualquier fecha" },
    { value: "1", label: "Últimas 24 horas" },
    { value: "3", label: "Últimos 3 días" },
    { value: "7", label: "Últimos 7 días" },
    { value: "14", label: "Últimos 14 días" },
    { value: "30", label: "Últimos 30 días" },
    { value: "60", label: "Últimos 60 días" },
    { value: "90", label: "Últimos 90 días" },
    { value: "180", label: "Últimos 6 meses" },
    { value: "365", label: "Último año" },
    { value: "730", label: "Últimos 2 años" },
    { value: "custom", label: "Rango a medida" },
];

export const onMatchesRange = (item, range, field = "createdAt") => {

    if (!range || !range.value) return true;

    const DATE = item?.[field] ? new Date(item[field]) : null;

    if (!DATE) return false;

    if (range.value !== "custom") {

        const FROM_DATE = new Date();

        FROM_DATE.setDate(FROM_DATE.getDate() - Number(range.value));

        return DATE >= FROM_DATE;
    }

    if (range.from) {
        const FROM_DATE = new Date(range.from);
        FROM_DATE.setHours(0, 0, 0, 0);
        if (DATE < FROM_DATE) return false;
    }

    if (range.to) {
        const TO_DATE = new Date(range.to);
        TO_DATE.setHours(23, 59, 59, 999);
        if (DATE > TO_DATE) return false;
    }

    return true;
};

export const useDateRange = () => {

    const [useRange, setRange] = useState({ value: "", from: null, to: null });

    return {
        useRange,
        onChangeValue: (value) => setRange({ value, from: null, to: null }),
        onChangeFrom: (from) => setRange((prev) => ({ ...prev, from })),
        onChangeTo: (to) => setRange((prev) => ({ ...prev, to })),
    };
};
